import React, { FC } from 'react';

import AppLogo from '../../../../../assets/logo.svg';

export const Logo: FC = () => {
  return <img alt="Logo" src={AppLogo} />;
};
